import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import { Button, ButtonType } from 'swag-client-common/components/ui/button';
import { PopupDialog } from 'swag-client-common/components/info/popup-dialog';
import css from './unavailable-sizes-popup.scss';
export const classes = {
  paper: css.paper
};
export const titleClasses = {
  root: css.popupHeader
};
export const UnavailableSizesPopup = ({
  open,
  unavailableSizes,
  isLimitedEdition,
  onClose
}) => {
  const [sizesWithQty, setSizesWithQty] = useState('');
  useEffect(() => {
    const keys = Object.keys(unavailableSizes !== null && unavailableSizes !== void 0 ? unavailableSizes : {});
    let sizesWithQtyStr = '';
    keys.forEach((key, index, array) => {
      const isLastSize = index === keys.length - 1;
      if (isLastSize && array.length > 1) {
        sizesWithQtyStr += ' and ';
      }
      sizesWithQtyStr += `${unavailableSizes[key]} (${key})`;
      if (!isLastSize) {
        sizesWithQtyStr += ', ';
      }
    });
    setSizesWithQty(sizesWithQtyStr);
  }, [unavailableSizes]);
  return /*#__PURE__*/React.createElement(PopupDialog, {
    open: open,
    onClose: onClose,
    dataPopup: "UnavailableSizesPopup",
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("header", {
      className: css.header
    }, "Please review and adjust the selected sizes"), /*#__PURE__*/React.createElement("div", {
      className: css.sizes
    }, sizesWithQty), /*#__PURE__*/React.createElement("div", {
      className: css.text
    }, "The sizes above were submitted through your size collection link but unfortunately could not be populated on this page because these sizes are no longer available for this item. Please adjust your sizes to select ones that are available, or contact us via chat if you need help finding an alternative!"), /*#__PURE__*/React.createElement("div", {
      className: css.buttonWrapper
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Cancel",
      type: ButtonType.primary,
      onClick: onClose,
      dataButton: "Cancel",
      className: classnames(css.button, {
        [css.orangeButton]: isLimitedEdition
      })
    }, "Close"))),
    classes: classes,
    titleHeader: css.popupHeader,
    titleClasses: titleClasses,
    contentClass: css.contentWrapper,
    closeClass: classnames(css.closeClass, {
      [css.orangeClose]: isLimitedEdition
    })
  });
};